import { render, staticRenderFns } from "./blogPost.vue?vue&type=template&id=6975f0be"
import script from "./blogPost.vue?vue&type=script&lang=js"
export * from "./blogPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports